////////LIBRARY/////////
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import _, { find, filter, isUndefined, map } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
///////COMPONENTS///////
import routeList, { uriList } from '../../settings/RouteList'
import { loginActionCreators } from '../../../store/actions'

const PrivateRoutes = ({ children, ...rest }) => {
	const { user } = useSelector((state) => ({
		user: state.user,
	}))

	const actionsLogin = bindActionCreators(loginActionCreators, useDispatch())

	let authorized = false

	let nestedRoutes
	let route

	// Check if nested path => To improve maybe ?
	if (!rest.computedMatch?.isExact || isUndefined(rest.computedMatch)) {
		nestedRoutes = filter(routeList, (o) => !isUndefined(o.routes))
	} else {
		route = find(routeList, { path: rest.path })
	}

	// If nested path
	if (user.identity.rolePrivileges && nestedRoutes) {
		map(nestedRoutes, (rt) => {
			map(rt.routes, (nest) => {
				// Auth can contain multiples values, so we need to check if it is array
				if (_.isArray(nest.auth)) {
					map(nest.auth, (auth) => {
						const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === auth) ? true : false
						if (f) authorized = true
					})
				} else {
					const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === nest.auth) ? true : false
					// If user has privilege which match route called
					if (f) authorized = true
				}
			})
		})
	}

	// Classic path
	if (user.identity.rolePrivileges && route) {
		// Auth can contain multiples values, so we need to check if it is array
		if (_.isArray(route.auth)) {
			map(route.auth, (auth) => {
				const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === auth) ? true : false
				if (f) authorized = true
			})
		} else {
			// If user has privilege which match route called
			authorized = find(user.identity.rolePrivileges.privileges, (o) => o.label === route.auth) ? true : false
		}
		// route has auth empty => no rights needed
		if (route.auth === '') authorized = true
	}

	// Temp patch, while we add rights to route
	//authorized = true
	// This code seems to be non-sense, better redirecting at home instead of being logout ?
	/*if (!authorized && user.isConnected) {
		actionsLogin.getLogout()
	}*/

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Route
			{...rest}
			render={
				(props) =>
					user.isConnected ? (
						authorized ? (
							children
						) : (
							<Redirect
								to={{
									pathname: uriList.home,
									state: { from: props.location },
								}}
							/>
						)
					) : (
						<Redirect
							to={{
								pathname: uriList.login,
								state: { from: props.location },
							}}
						/>
					)
				//children
			}
		/>
	)
}

PrivateRoutes.propTypes = {}

export default PrivateRoutes
